<template>
  <Card dis-hover :bordered="false">
    <h3 v-if="tableTitle" slot="title">
      <Icon type="grid"></Icon>&nbsp;{{tableTitle}}
    </h3>
    <div v-if="settings.needSearch">
      <m-query ref="queryForm" @onSubmit="onSubmit" :formData="formData"
               :needValidation="settings.needValidation" :needClear="settings.needClear" :position="settings.position" :onlyLeftPart="settings.onlyLeftPart" :loading="loading"></m-query>
    </div>
    <slot name="form"></slot>
    <slot name="button"></slot>
    <m-table ref="iTable" v-if="!hideTable" :thDrag="thDrag" :columnDrag="columnDrag" :height="height" :loading="loading" :data="data" :columns="columns" :table-buttons="tableButtons"
             :titleRemarksShow="titleRemarksShow" :titleRemarks="titleRemarks"
             :row-class-name="rowClassName"
             v-bind='$attrs'
             :noDataText="noDataText"
             @onView="onView" @onEdit="onEdit" @onDelete="onDelete" @rowClick="onRowClick" @select="onSelect"
             @selectCancel="onSelectCancel" @onSelectionChange="onSelectionChange" @selectAll="onSelectAll"
             @onExportClick="onExportClick" @expand="onExpand">
             <span slot="buttonLeft">
                <slot name="buttonLeft"></slot>
            </span>
            <span slot="tips">
              <set-table v-if="settings.needSetTable" :columns="columns.columns" :buttonSize="settings.setTableBtnSize" @setTableUpdate="setTableUpdate" :filterColumns="filterColumns"></set-table>
              <slot name="tips"></slot>
            </span>
            <span slot="buttonRight">
              <slot name="buttonRight"></slot>
            </span>
             
             <div slot="tableHeader">
              <slot name="tableHeader">
              </slot>
             </div>
    </m-table>
    <slot name="total"></slot>
    <m-pagination v-if="settings.needPager" :showElevator="settings.showElevator" :showSizer="settings.showSizer"
                  :currentPage="page" :pageSize="pageSize" :total="total" :pageSizeOpts="settings.pageSizeOpts"
                  @on-page-size-change="onPageSizeChange" @on-current-page-change="onCurrentPageChange"></m-pagination>
  </Card>
</template>

<script>
  import mQuery from '../query/index';
  import mTable from '../table/index';
  import mPagination from '../pagination/index';

  export default {
    name: 'mAssemblyTable',
    components: {mQuery, mTable, mPagination},
    data() {
      return {
        condition: {},
        page: this.currentPage,
        myPageSize: this.pageSize
      };
    },
    props: {
      filterColumns: {},
      rowClassName: {},
      hideTable: {
        type: Boolean,
        default: false
      },
      currentPage: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 10
      },
      tableButtons: {
        type: Object,
        default() {
          return {};
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      height: {
        type: Number
      },
      tableTitle: {
        type: String,
        default: ''
      },
      formData: {
        type: Object,
        default() {
          return {
            items: [],
            row: 0,
            buttons: {}
          };
        }
      }, // 查询条件配置
      columns: {
        type: Object,
        default() {
          return {
            showCheckbox: {type: Boolean, default: true},
            columns: {
              type: Array,
              default() {
                return [];
              }
            },
            buttons: {
              type: Object,
              default() {
                return {
                  view: {
                    type: Boolean,
                    default: false
                  },
                  edit: {
                    type: Boolean,
                    default: false
                  },
                  delete: {
                    type: Boolean,
                    default: false
                  },
                  selfDef: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                };
              }
            }
          };
        }
      }, // 数据列定义
      data: {
        type: Array,
        default() {
          return [];
        }
      }, // 表格数据
      total: {
        type: Number,
        default: 1
      }, // 总记录数
      settings: {
        type: Object,
        default() {
          return {
            needPager: {
              type: Boolean,
              default: true
            }, // 是否需要分页，默认true
            showElevator: {
              type: Boolean,
              default: true
            }, // 分页组件是否显示电梯导航，默认true
            showSizer: {
              type: Boolean,
              default: true
            }, // 是否显示每页显示多少条数据的下拉框，默认true
            pageSizeOpts: {
              type: Array,
              default() {
                return [10, 30, 50, 80];
              }
            }, // 每页显示多少条数据配置
            needSearch: {
              type: Boolean,
              default: true
            }, // 是否需要查询条件，默认true
            needValidation: {
              type: Boolean,
              default: false
            }, // 查询条件是否需要验证，默认false
              onlyLeftPart: {
                  type: Boolean,
                  default: false
              }, // 查询区域是否只有左区域（没有右边两个按钮），默认false
            needSetTable: {
              type: Boolean,
              default: false
            }, // 是否需要自定义列顺序
            setTableBtnSize: {
              type: String,
              default: 'default'
            }
          };
        }
      },
      // 列宽拖拉调整
      thDrag: {
        type: Boolean,
        default: false
      },
      // 列顺序拖动
      columnDrag: {
        type: Boolean,
        default: false
      },
      titleRemarksShow: {
        type: Boolean,
        default: false
      }, // 是否展示按钮与表格之间的备注描述
      titleRemarks: {
        type: String,
        default: ''
      }, // 按钮与表格之间的备注描述
      noDataText: {
        type: String,
        default () {
          return this.$t('page.table.noDataText');
        },
      }
    },
    methods: {
      setTableUpdate (columns) {
        this.columns.columns = columns;
      },
      // 提交按钮点击时触发
      onSubmit(condition) {
        this.condition = condition;
        this.page = 1;
        this.$emit('onSubmit', this.page, this.myPageSize, this.condition);
      },
      // 页容量改变时触发
      onPageSizeChange(pageSize) {
        let queryFormRef = this.$refs['queryForm'];
        if (queryFormRef === undefined || queryFormRef.validateForm()) {
          this.page = 1;
          this.myPageSize = pageSize;
          this.$emit('onPageSizeChange', this.page, this.myPageSize, this.condition);
        }
      },
      // 当前页改变时触发
      onCurrentPageChange(current) {
        let queryFormRef = this.$refs['queryForm'];
        if (queryFormRef === undefined || queryFormRef.validateForm()) {
          this.page = current;
          this.$emit('onCurrentPageChange', this.page, this.myPageSize, this.condition);
        }
      },
      onView(row, column, index) {
        this.$emit('onView', row, column, index);
      },
      onEdit(row, column, index) {
        this.$emit('onEdit', row, column, index);
      },
      onDelete(row, column, index) {
        this.$emit('onDelete', row, column, index);
      },
      onRowClick(row, index) {
        this.$emit('onRowClick', row, index);
      },
      onSelect(selection, row) {
        this.$emit('onSelect', selection, row);
      },
      onSelectCancel(selection, row) {
        this.$emit('onSelectCancel', selection, row);
      },
      onSelectionChange(selection) {
        this.$emit('onSelectionChange', selection);
      },
      onSelectAll(selection) {
        this.$emit('onSelectAll', selection);
      },
      onExportClick() {
        this.$emit('onExportClick');
      },
        onExpand(row, status) {
            this.$emit('onExpand', row, status);
        },
        // 获取选中行
        getSelection() {
            return this.$refs['iTable'].getSelection();
        },
        validateForm() {
            return this.$refs['queryForm'].validateForm();
        },
        validateFieldForm(index) {
            return this.$refs.queryForm.validateFieldForm(index);
        },
    },
    watch: {
      currentPage (newVal) {
        if (newVal) {
          this.page = newVal;
        }
      },
      pageSize (newVal) {
        if (newVal) {
          this.myPageSize = newVal;
        }
      },
      columns: {
        handler() {
          this.columns = this.columns;
        },
        deep: true
      }
    }
  };
</script>

<style lang="less" scoped>
  h3 {
    letter-spacing: 2px;
  }

  .tableButtons {
    padding: 12px 0;
  }
</style>
<style lang="less">
  .m-collapse > .m-collapse-item > .m-collapse-header {
    padding-left: 16px;
  }
</style>
